module.exports = __webpack_public_path__ + "static/media/faces-WIP-removebg-preview.1d0fd720.png";